export default "__VITE_ASSET__B$HaPUnt__"